@if (!hideTimer) {
  <div class="task-screen-element">
    <div class="timer-bar-empty"></div>
    <div #timerBar class="timer-bar-colored" [style.width]="filledWidth + '%'"></div>
    <div #timerBox class="timer-counter-box font-24" [style]="{'background': ' ' + darkContainerColor, 'color': '#000000', 'border-color': ' ' + taskBarColor}"
      [class.timer-counter-box-blink]="highlight">
      <p id="timer-points" [class.float-up]="floatPointsUp">{{currentPointTotal}}</p>
    </div>
  </div>
}